import { DataSource, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommMessageText extends Layout {
	panelMobileCommMessageText: Panel;
	sourceMobileCommMessage: DataSource;
}
